export default "__VITE_ASSET__P13VGN1L__"